const phoneCC = {
  props: {
    classPhoneCC: ".phoneCC",
    classAnchorCC: ".anchorCC",
  },

  init: async function () {
    try {
      const targetCountry = await this.waitForCountryCode();
      if (targetCountry) {
        this.setPhoneCC(targetCountry);
      }
    } catch (error) {
      console.error("Error fetching country code in:", document.documentElement.lang);
      console.error(error);
      this.setPhoneCC("us");
    }
  },

  waitForCountryCode: function () {
    return new Promise((resolve, reject) => {
      const countdown = setInterval(() => {
        if (bcl.contextHub) {
          const targetCountry = bcl.contextHub.getItem("profile", "country_code");
          if (targetCountry) {
            clearInterval(countdown);
            resolve(targetCountry);
          }
        }
      }, 1000);

      setTimeout(() => {
        clearInterval(countdown);
        reject(new Error("Failed to obtain country code from contextHub"));
      }, 5000); // Timeout after 5 seconds to avoid an infinite loop. Resolve to US as fallback
    });
  },

  setPhoneCC: function (targetCountry) {
    const phoneNodes = document.querySelectorAll(this.props.classPhoneCC);
    let matchFound = false;

    phoneNodes.forEach((phoneNode) => {
      const { phone, country } = phoneNode.dataset;

      if (!phone || !country) {
        console.log("Missing phone or country data in:", phoneNode);
        return;
      } // Avoid failures if dataset properties are missing

      if (country.toLowerCase() === targetCountry.toLowerCase()) {
        matchFound = this.updatePhoneAnchors(phoneNode);
      }

      this.updatePhoneLinks(phone);
    });

    if (!matchFound) {
      if (targetCountry === "us") {
        // fallback to hardcoded US phone in case also US do not match
        const phoneAnchors = document.querySelectorAll(this.props.classAnchorCC);
        bcl.u.forEach(phoneAnchors, (phoneAnchor) => {
          phoneAnchor.href = "tel:(800) 227-2356";
          phoneAnchor.innerText = "(800) 227-2356";
          phoneAnchor.setAttribute("data-data-phone", "US");
        });
      } else {
        // fallback tu US if no country match
        this.setPhoneCC("us");
      }
    }
  },

  updatePhoneAnchors: function (phoneNode) {
    const phoneAnchors = document.querySelectorAll(this.props.classAnchorCC);
    const isWedding = document.querySelector("html").dataset.template == "bwd-page";
    let phone = phoneNode.dataset.phone;
    if (isWedding) {
      if (!phoneNode.dataset.phonewed) {
        return false;
      } else {
        phone = phoneNode.dataset.phonewed;
      }
    }

    phoneAnchors.forEach((phoneAnchor) => {
      const formattedPhone = isWedding ? phoneNode.dataset.phonewed.replace(/ /g, "") : phoneNode.dataset.phone.replace(/ /g, "");
      phoneAnchor.href = "tel:" + formattedPhone;
      phoneAnchor.innerText = phone;
      phoneAnchor.setAttribute("data-data-phone", phoneNode.dataset.country.toUpperCase());
    });

    return true;
  },

  updatePhoneLinks: function (phone) {
    if (!phone) {
      return;
    }

    const formats = [phone.replace(/ /g, ""), phone.replace(/ /g, "%20")];

    formats.forEach((formattedPhone) => {
      const links = document.querySelectorAll(`a[href='tel:${formattedPhone}']`);
      links.forEach((link) => {
        link.setAttribute("data-data-phone", phone.toUpperCase());
      });
    });
  },
};

export default phoneCC;
